import { DashboardReqOptions } from '../../../features/bot/modules/bot-dashboard/shared/store';
import { Bot, BotIntent, BotVariable } from '../../models/bot.model';

export class CreateBot {
  static readonly type = '[Bot] Create';

  constructor(public name: string, public template: string) { }
}

export class GetBot {
  static readonly type = '[Bot] Get';

  constructor(public id: string) { }
}

export class UpdateBot {
  static readonly type = '[Bot] Update';

  constructor(public bot: Bot) { }
}

export class ClearBot {
  static readonly type = '[Bot] Clear';

  constructor() { }
}

export class SwitchBotActivity {
  static readonly type = '[Bot] Switch Activity';

  constructor() { }
}

export class SwitchBotNotifications {
  static readonly type = '[Bot] Switch Notifications';

  constructor() { }
}

export class UpdateBotImage {
  static readonly type = '[Bot] Update Image';

  constructor(public fileData: any) { }
}

export class CreateBotConnection {
  static readonly type = '[Bot] Create Connection';

  constructor(public provider: string, public providerData: any) { }
}

export class GetBotConnections {
  static readonly type = '[Bot] Get Connections';

  constructor() { }
}

export class UpdateBotConnection {
  static readonly type = '[Bot] Update Connection';

  constructor(public provider: string, public providerData: any) { }
}

export class UpdateBotTemplateData {
  static readonly type = '[Bot] Update Template Data';

  constructor(public templateData: any) { }
}

export class GetBotVariables {
  static readonly type = '[Bot] Get Variables';

  constructor(public payload: DashboardReqOptions) { }
}

export class UpdateBotVariable {
  static readonly type = '[Bot] Update Variable';

  constructor(public variable: BotVariable) { }
}

export class GetBotIntents {
  static readonly type = '[Bot] Get Intents';

  constructor() { }
}

export class UpdateBotIntent {
  static readonly type = '[Bot] Update Intent';

  constructor(public intent: BotIntent) { }
}

export class CreateBotShopifyTool {
  static readonly type = '[Bot] Create Shopify Tool';

  constructor(public shopId: string) { }
}

export class GetBotMessageBuffer {
  static readonly type = '[Bot] Get Message Buffer';

  constructor() { }
}

export class CreateBotMessageBuffer {
  static readonly type = '[Bot] Create Message Buffer';

  constructor(public period: string) { }
}

export class UpdateBotMessageBuffer {
  static readonly type = '[Bot] Update Message Buffer';

  constructor(public period: string) { }
}

export class GetBotFilters {
  static readonly type = '[Bot] Get Filters';

  constructor() { }
}

export class GetBotScenarios {
  static readonly type = '[Bot] Get Scenarios';

  constructor() { }
}

export class GetBotCollections {
  static readonly type = '[Bot] Get Collections';

  constructor() { }
}

export class GetBotCategories {
  static readonly type = '[Bot] Get Categories';

  constructor() { }
}

export class GetBotProducts {
  static readonly type = '[Bot] Get Products';

  constructor() { }
}

export class GetBotTags {
  static readonly type = '[Bot] Get Tags';

  constructor() { }
}

export class UpdateBotTag {
  static readonly type = '[Bot] Update Tag';

  constructor(public tag: any) { }
}

export class GetBotTeamExtended {
  static readonly type = '[Bot] Get Team Extended';
}

export class GetBotMails {
  static readonly type = '[Bot] Get Mails';
}

export class GetBotEntities {
  static readonly type = '[Bot] Get Entities';
}

// Bot dashboard

export class GetBotTeam {
  static readonly type = '[Bot] Get Team';
}
